import styled, { css } from "styled-components";
import { IndicatorLayout } from "../consts/indicator-layout";
import { IndicatorDefaultBox } from "./indicator.default.box";

export const IndicatorPrimaryTextDefaultBox = styled.div<{active?: boolean, displayLayout?: IndicatorLayout}>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    font-size: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "1.2rem" : "1rem"};
    color: ${({theme, active}) => active ? theme.colors.textLight : theme.colors.textMiddleDark };
    transition: color 0.2s ease;
    text-align: center;
    ${({displayLayout}) => displayLayout === IndicatorLayout.List ? css`
        ${IndicatorDefaultBox}:hover & {
            color: ${({theme}) => theme.colors.textLight};
        }
    ` : "" }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 1.2rem;
        color: ${({theme}) => theme.colors.textLight};
    }
`;
